import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { baseUrl } from 'src/environments/environments';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient) { }

  login(data: any): Observable<any> {
    return this.http.post(`${baseUrl}login`, data);
  }

  resetPassword(data: any): Observable<any> {
    return this.http.post(`${baseUrl}reset`, data);
  }

  resetConfirm(data: any): Observable<any> {
    return this.http.post(`${baseUrl}reset/confirm`, data);
  }
}
